export default __webpack_public_path__ + "static/media/FemailUser.d8e6059e.svg";